import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import api from '../../services/api';
import styles from './PaymentResult.module.css';

const PaymentSuccess = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('session_id');
  const [verifying, setVerifying] = useState(!!sessionId);
  const [result, setResult] = useState(null);

  useEffect(() => {
    if (!sessionId) {
      // 没有 session_id 也尝试获取 VIP 状态
      (async () => {
        try {
          const { data } = await api.get('/payment/check-vip-status');
          if (data?.is_vip) {
            setResult({
              status: 'success',
              message: '会员开通成功',
              vip_expires_at: data.vip_expires_at,
              days_remaining: data.days_remaining,
            });
          }
        } catch {
          // ignore
        } finally {
          setVerifying(false);
        }
      })();
      return;
    }

    let cancelled = false;
    (async () => {
      try {
        // 先验证支付会话
        const { data } = await api.get(`/payment/verify-session/${sessionId}`);
        if (cancelled) return;

        if (data?.status === 'success') {
          // 验证成功后再获取完整 VIP 状态
          try {
            const { data: vipData } = await api.get('/payment/check-vip-status');
            if (!cancelled) {
              setResult({
                ...data,
                days_remaining: vipData?.days_remaining,
              });
            }
          } catch {
            if (!cancelled) setResult(data);
          }
        } else {
          if (!cancelled) setResult(data);
        }
      } catch (err) {
        console.error('验证支付状态失败:', err);
        if (!cancelled) {
          setResult({ status: 'pending', message: '支付状态确认中，请稍后刷新查看' });
        }
      } finally {
        if (!cancelled) setVerifying(false);
      }
    })();
    return () => { cancelled = true; };
  }, [sessionId]);

  const formatDate = (dateStr) => {
    if (!dateStr) return '';
    const d = new Date(dateStr);
    return new Intl.DateTimeFormat('zh-CN', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    }).format(d);
  };

  return (
    <div className={styles.page}>
      <div className={styles.card}>
        <div className={`${styles.iconCircle} ${styles.iconSuccess}`}>
          <span className="material-symbols-outlined">check_circle</span>
        </div>

        <h1 className={styles.title}>支付成功！</h1>

        {verifying ? (
          <p className={styles.desc}>正在确认支付状态…</p>
        ) : result?.vip_expires_at ? (
          <div className={styles.details}>
            <p className={styles.desc}>恭喜，您的 VIP 会员已开通！</p>
            <div className={styles.infoBox}>
              <div className={styles.infoRow}>
                <span className={styles.infoLabel}>会员有效期至</span>
                <span className={styles.infoValue}>{formatDate(result.vip_expires_at)}</span>
              </div>
              {result.days_remaining && (
                <div className={styles.infoRow}>
                  <span className={styles.infoLabel}>剩余天数</span>
                  <span className={styles.infoValue}>{result.days_remaining} 天</span>
                </div>
              )}
            </div>
          </div>
        ) : (
          <p className={styles.desc}>
            {result?.message || '支付已完成，VIP 会员将在几分钟内生效。'}
          </p>
        )}

        <div className={styles.actions}>
          <button className={styles.primaryBtn} onClick={() => navigate('/')}>
            返回首页
          </button>
          <button className={styles.secondaryBtn} onClick={() => navigate('/profile')}>
            查看我的账户
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccess;

